import { FIELD_VALUES } from '@funnels/constants';

import { BASE_DATA, SERVER_EMPLOYMENTS1 } from '../serverData';

const EMPLOYMENT_HISTORY_BASE = {
  ...BASE_DATA,
};

const PREVIOUS_EMPLOYMENT = {
  ...SERVER_EMPLOYMENTS1,
  type: FIELD_VALUES.PREVIOUS,
  employmentType: FIELD_VALUES.EMPLOYEE,
};

const MATERNITY_LEAVE_EMPLOYMENT = {
  ...SERVER_EMPLOYMENTS1,
  employmentBasis: FIELD_VALUES.MATERNITY_LEAVE,
};

const EMPLOYMENT_HISTORY_PREVIOUS = {
  ...EMPLOYMENT_HISTORY_BASE,
  employments: [PREVIOUS_EMPLOYMENT],
};

const EMPLOYMENT_HISTORY_PREVIOUS_SELF_EMPLOYED = {
  ...EMPLOYMENT_HISTORY_BASE,
  employments: [{ ...PREVIOUS_EMPLOYMENT, employmentType: FIELD_VALUES.SELF_EMPLOYED }],
};

const EMPLOYMENT_HISTORY_PRIMARY_NOT_WORKING = {
  ...EMPLOYMENT_HISTORY_BASE,
  employments: [{ type: FIELD_VALUES.PRIMARY, employmentType: FIELD_VALUES.NOT_WORKING }],
};

const EMPLOYMENT_HISTORY_PREVIOUS_NOT_WORKING = {
  ...EMPLOYMENT_HISTORY_BASE,
  employments: [{ ...PREVIOUS_EMPLOYMENT, employmentType: FIELD_VALUES.NOT_WORKING }],
};

const EMPLOYMENT_HISTORY_PREVIOUS_MATERNITY_LEAVE = {
  ...EMPLOYMENT_HISTORY_BASE,
  employments: [MATERNITY_LEAVE_EMPLOYMENT],
};

export {
  EMPLOYMENT_HISTORY_BASE,
  EMPLOYMENT_HISTORY_PREVIOUS,
  EMPLOYMENT_HISTORY_PREVIOUS_NOT_WORKING,
  EMPLOYMENT_HISTORY_PREVIOUS_SELF_EMPLOYED,
  EMPLOYMENT_HISTORY_PREVIOUS_MATERNITY_LEAVE,
  EMPLOYMENT_HISTORY_PRIMARY_NOT_WORKING,
};
